import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { EMPTY_FILTERS } from "@/lib/constants";
import { Card } from "@/components/common";

const inr = (v) => `₹${Math.round(v || 0).toLocaleString("en-IN")}`;

const Change = ({ cur, prev }) => {
  if (prev == null) return <span className="text-xs text-slate-400">new</span>;
  const d = +(cur - prev).toFixed(1);
  if (!d) return <span className="text-xs text-slate-400">same</span>;
  return <span className={`whitespace-nowrap text-xs font-semibold ${d > 0 ? "text-red-600" : "text-emerald-600"}`}>{d > 0 ? "▲" : "▼"} {Math.abs(d)} pts</span>;
};

export const OutletTable = ({ rows, compare, brand, range }) => {
  const nav = useNavigate();
  const { setFilters, setComplaintSentiment } = useApp();
  const open = (outlet) => {
    setComplaintSentiment(["Negative"]);
    setFilters({ ...EMPTY_FILTERS, brand: [brand], outlet: [outlet], preset: "custom", date_from: range.from, date_to: range.to });
    nav("/complaints");
  };
  const max = Math.max(1, ...rows.map((r) => r.negative_pct));
  return (
    <Card title="Outlets" subtitle="Sorted by negative feedback. Click an outlet to see its complaints." testid="outlet-table-card">
      <div className="-mx-2 overflow-x-auto">
        <table className="w-full min-w-[720px] text-sm">
          <thead><tr className="border-b text-left text-xs uppercase tracking-wider text-slate-400">
            <th className="px-2 py-2">Outlet</th><th className="px-2 text-right">Feedback</th><th className="px-2 text-right">Negative</th>
            <th className="w-[240px] px-2">Negative %</th><th className="px-2 text-right">Avg rating</th><th className="px-2 text-right">Refund given</th><th className="px-2">Top issue</th>
          </tr></thead>
          <tbody>
            {rows.map((o) => (
              <tr key={o.outlet} onClick={() => open(o.outlet)} className="cursor-pointer border-b border-slate-100 transition-colors hover:bg-slate-50" data-testid={`outlet-row-${o.outlet}`}>
                <td className="px-2 py-3 font-medium text-slate-900">{o.outlet}</td>
                <td className="px-2 text-right text-slate-600">{o.total}</td>
                <td className="px-2 text-right font-semibold text-slate-900">{o.negative}</td>
                <td className="px-2">
                  <div className="flex items-center gap-2">
                    <div className="h-2 w-20 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-red-500" style={{ width: `${(100 * o.negative_pct) / max}%` }} /></div>
                    <span className="w-11 text-right font-medium">{o.negative_pct}%</span>
                    {compare && <Change cur={o.negative_pct} prev={o.prev_negative_pct} />}
                  </div>
                </td>
                <td className="px-2 text-right">{o.avg_rating ?? "—"}</td>
                <td className="px-2 text-right">{inr(o.refund_given)}</td>
                <td className="px-2 text-slate-600">{o.top_issue || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!rows.length && <p className="py-10 text-center text-sm text-slate-400">No feedback in this period.</p>}
      </div>
    </Card>
  );
};
